//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name:"index-scroll",
    props:{
        _class:{
            default:null
        },
        classh:{
            default:null
        },
        isComputeH:{
            default:false
        }
    },
    methods:{
        loadData(){ //加载数据
            this.$emit("load",true);
        },
        sumH(){ //计算高度
            if(!this.isComputeH){
                window.onresize = this.sumH;
                let {classh} = this.$props;
                let style;
                classh = classh || [];
                //获取当前组件位置
                let _component = document.getElementsByClassName(this.$props._class)[0];
                let h = document.documentElement.clientHeight;
                for(var i = 0;i<classh.length;i++){
                    let ev = document.getElementsByClassName(classh[i]);
                    if(ev[0] == undefined){//如果元素不存在跳过本次循环执行下次循环
                        continue;
                    }else{
                        style = window.getComputedStyle(ev[0],null);
                    }; 
                    h -= parseInt(style.height.replace("px",""));
                }
                console.log(_component)
                _component.style.height = h + "px";
            }
            
        }
    },
    directives:{
        scroll:{
            inserted(el,binding,name){
                el.onscroll = (ev) => {
                    let {
                        scrollTop,  //当前滚动条不算可是高度的位置
                        clientHeight,   //可视高度
                        scrollHeight,   //滚动条高度
                    } = ev.target;
                    if(scrollTop + clientHeight >= scrollHeight - 50){
                        binding.value();
                    }
                }
            }
        },
        load:{
            inserted(el,binding,name){
                binding.value();
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/index-scroll.vue